import { IStylesParamsNumbersKeys } from './stylesParamsKeys';
import { MobileSettingsKeys, SettingsKeys } from './appSettingsKeys';
import { cleanNulls } from './utils';
import { ISettingsParamsNumbersKeys } from './settingsParamsKeys';
const stylesParamNumberKeyToAppSettingsMapper = {
  borderWidth: SettingsKeys.BORDER_WIDTH,
  filterBorderWidth: SettingsKeys.CATEGORY_BORDER_WIDTH,
  [IStylesParamsNumbersKeys.filterBorderWidth + "\u25B6\uFE0Em"]: MobileSettingsKeys.MOBILE_CATEGORY_BORDER_WIDTH,
  filterBorderRadius: SettingsKeys.CATEGORY_BORDER_RADIUS,
  filterSpacing: SettingsKeys.CATEGORY_SPACING,
  overlappingSidePadding: SettingsKeys.OVERLAPPING_SIDE_PADDING,
  overlappingVerticalPadding: SettingsKeys.OVERLAPPING_VERTICAL_PADDING,
  stripBorderWidth: SettingsKeys.STRIP_BORDER_WIDTH,
  stripSidePadding: SettingsKeys.STRIP_SIDE_PADDING,
  stripVerticalPadding: SettingsKeys.STRIP_VERTICAL_PADDING,
  imageAndTextRatio: SettingsKeys.IMAGE_AND_TEXT_RATIO,
  serviceDividerWidth: SettingsKeys.DIVIDER_WIDTH,
  [IStylesParamsNumbersKeys.serviceDividerWidth + "\u25B6\uFE0Em"]: MobileSettingsKeys.MOBILE_DIVIDER_WIDTH,
  classicSidePadding: SettingsKeys.CLASSIC_SIDE_PADDING,
  classicVerticalPadding: SettingsKeys.CLASSIC_VERTICAL_PADDING,
  gridSidePadding: SettingsKeys.GRID_SIDE_PADDING,
  gridVerticalPadding: SettingsKeys.GRID_VERTICAL_PADDING,
  bookButtonBorderWidth: SettingsKeys.BUTTON_BORDER_WIDTH,
  bookButtonCornerRadius: SettingsKeys.BUTTON_CORNER_RADIUS,
  mobileWidgetTitleFontSize: MobileSettingsKeys.MOBILE_MULTI_OFFERINGS_TITLE_FONT_SIZE,
  mobileFilterTitleFontSize: MobileSettingsKeys.MOBILE_CATEGORY_NAME_FONT_SIZE,
  dropdownBorderWidth: MobileSettingsKeys.MOBILE_CATEGORY_BORDER_WIDTH,
  mobileServiceNameFontSize: MobileSettingsKeys.MOBILE_OFFERING_NAME_FONT_SIZE,
  mobileServiceTaglineFontSize: MobileSettingsKeys.MOBILE_OFFERING_TAGLINE_FONT_SIZE,
  mobileMoreInfoButtonFontSize: MobileSettingsKeys.MOBILE_MORE_INFO_LABEL_FONT_SIZE,
  mobileServiceDetailsFontSize: MobileSettingsKeys.MOBILE_OFFERING_DETAILS_FONT_SIZE,
  mobileBookButtonFontSize: MobileSettingsKeys.MOBILE_BUTTON_TEXT_FONT_SIZE,
  mobileExplorePlansFontSize: MobileSettingsKeys.MOBILE_EXPLORE_PLANS_FONT_SIZE,
  [IStylesParamsNumbersKeys.borderWidth + "\u25B6\uFE0Em"]: MobileSettingsKeys.MOBILE_BORDER_WIDTH,
  [IStylesParamsNumbersKeys.classicSidePadding + "\u25B6\uFE0Em"]: MobileSettingsKeys.MOBILE_SIDE_PADDING,
  [IStylesParamsNumbersKeys.classicVerticalPadding + "\u25B6\uFE0Em"]: MobileSettingsKeys.MOBILE_VERTICAL_PADDING,
  [IStylesParamsNumbersKeys.gridSidePadding + "\u25B6\uFE0Em"]: MobileSettingsKeys.MOBILE_SIDE_PADDING,
  [IStylesParamsNumbersKeys.gridVerticalPadding + "\u25B6\uFE0Em"]: MobileSettingsKeys.MOBILE_VERTICAL_PADDING,
  [IStylesParamsNumbersKeys.stripVerticalPadding + "\u25B6\uFE0Em"]: MobileSettingsKeys.MOBILE_STRIP_VERTICAL_PADDING
};
export function mergeAppSettingsNumbersToStyleParamsNumbers(appSettings) {
  function mapNumber(_ref) {
    let {
      appSettingsNumber
    } = _ref;
    return typeof appSettingsNumber !== 'undefined' ? Number(appSettingsNumber) : null;
  }
  const newNumbers = {};
  Object.keys(stylesParamNumberKeyToAppSettingsMapper).forEach(styleParamsNumberKey => {
    newNumbers[styleParamsNumberKey] = mapNumber({
      appSettingsNumber: appSettings[stylesParamNumberKeyToAppSettingsMapper[styleParamsNumberKey]]
    });
  });
  return cleanNulls(newNumbers);
}
const settingsParamsNumbersKeyToAppSettingsMapper = {
  cardsPerRow: SettingsKeys.LAYOUT_CARDS_PER_ROW,
  cardSpacing: SettingsKeys.SPACE_BETWEEN_OFFERINGS,
  gridCardsSpacing: SettingsKeys.CARDS_SPACING,
  [ISettingsParamsNumbersKeys.gridCardsSpacing + "\u25B6\uFE0Em"]: MobileSettingsKeys.MOBILE_CARDS_SPACING,
  servicesDividerWidth: SettingsKeys.SERVICE_DIVIDER_WIDTH,
  stripCardSpacing: SettingsKeys.STRIP_SPACE_BETWEEN_OFFERINGS
};
export function mergeAppSettingsNumbersToSettingsParams(appSettings) {
  const appSettingsNumbers = {};
  Object.keys(settingsParamsNumbersKeyToAppSettingsMapper).forEach(settingsParamsNumbersKey => {
    const appSettingsValue = appSettings[settingsParamsNumbersKeyToAppSettingsMapper[settingsParamsNumbersKey]];
    if (typeof appSettingsValue !== 'undefined') {
      appSettingsNumbers[settingsParamsNumbersKey] = appSettingsValue;
    }
  });
  return cleanNulls(appSettingsNumbers);
}
//# sourceMappingURL=mergeNumbers.js.map